import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b26ecbb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"max-width":"200px","word-break":"break-all"} }
const _hoisted_3 = { class: "ellipsis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.value.length < _ctx.maxWord)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.value), 1))
      : (_openBlock(), _createBlock(_component_a_popover, {
          key: 1,
          trigger: "hover"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.value), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.value.slice(0, _ctx.maxWord)), 1)
          ]),
          _: 1
        }))
  ]))
}